import { ref } from 'vue';
import CardTaskTypesAPI from 'custom/dashboard/api/cardTaskTypes';

// The account's active task types, in catalog order.
export function useCardTaskTypes() {
  const taskTypes = ref([]);

  const fetchTaskTypes = async () => {
    const { data } = await CardTaskTypesAPI.get();
    taskTypes.value = data;
  };

  return { taskTypes, fetchTaskTypes };
}
